import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import MyDialog from "~/cabinet/vue/interface/dialog/MyDialog.vue";
import MyTimeSelectorInSeconds from "~/cabinet/vue/interface/form/MyTimeSelectorInSeconds.vue";
import {ref} from "vue";
import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "OperatorApplicationTempBanDialog"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    "visible": { type: Boolean },
    "visibleModifiers": {},
  },
  emits: /*@__PURE__*/_mergeModels(["input"], ["update:visible"]),
  setup(__props, { emit: __emit }) {

let emits = __emit;

let isVisible = _useModel<boolean>(__props, "visible");
function close() {
    isVisible.value = false;
}

let time = ref(3600);

function onApply() {
    emits("input", time.value);
    close();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MyDialog, {
    visible: _unref(isVisible),
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(isVisible) ? (isVisible).value = $event : isVisible = $event)),
    title: _unref(__)('Блокировка посетителя'),
    dialog: {width: '500px'},
    onApply: onApply
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(_unref(__)("Укажите срок блокировки")), 1),
      _createElementVNode("p", null, [
        _createVNode(MyTimeSelectorInSeconds, {
          modelValue: _unref(time),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(time) ? (time).value = $event : time = $event)),
          min: 60
        }, null, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})